// ============================================================
// การตั้งค่าการขาย (โครงการ) — /sale-project-settings
// ------------------------------------------------------------
// ตั้งค่า 3 เรื่อง
//   1) ข้อมูลติดต่อ Admin — ชื่อ / เบอร์ / LINE / อีเมล ที่โชว์บนหน้าประกาศ "ของโครงการที่ล็อกอินอยู่"
//   2) ข้อมูลบริษัท — โลโก้ ชื่อบริษัท เลขภาษี ช่องทางติดต่อ ฯลฯ "ของโครงการที่ล็อกอินอยู่"
//      ★ API api/admin/sale-site-settings ผูกโครงการจาก header project-id
//      ★ ยังไม่เคยบันทึก = API คืนข้อมูลโครงการมาเป็นค่าเริ่มต้น (is_default = true) กดบันทึกแล้วถึงเป็นของจริง
//      ★ โลโก้ + ชื่อ + ที่อยู่ + เบอร์ ตรงนี้คือสิ่งที่ขึ้นบนการ์ดโครงการในหน้าเว็บขาย
//        เดิมเป็นแถวเดียวทั้งระบบ กรอกที่โครงการเดียวไปขึ้นทุกโครงการ — เปลี่ยนเป็นรายโครงการแล้ว
//   3) การประกาศขาย — สวิตช์เปิด/ปิดว่าบล็อกไหนบนหน้ารายละเอียดทรัพย์จะขึ้นเว็บบ้าง
//
// ★ สวิตช์ (การประกาศขาย) มีผลกับเว็บขายจริง (CDS-Sale-Landing-Page หน้า /room)
//   ปิด = หน้าเว็บไม่แสดงบล็อกนั้น ไม่ใช่แค่ซ่อนในหน้าตั้งค่า
// ★ บล็อกที่ปิดจะจางลงทั้งการ์ด เพื่อให้กวาดตาเห็นว่าเหลืออะไรบนหน้าเว็บบ้าง
// ★ คีย์สวิตช์ต้องตรงกับ DISPLAY_KEYS ฝั่ง backend
//   (CDS-P2-Backend/modules/sale-project-setting/sale-project-setting.service.js)
// ============================================================

import React, { Component } from "react";
import Resizer from "react-image-file-resizer";
import PropertyNavbar from "../../components/PropertyNavbar.js";
import { GET, PUT, alert, loading, getCurrentProject, hasPermission, onlyPhoneDigits } from "../../components/CustomComponent.js";
import { stripJuristic } from "../../components/text-sanitize.js";

import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
import "../../assets/css/property.css";
import "../../assets/css/property_form.css";
import "../../assets/css/property-theme-cds.css";

// เมนูฝั่งซ้าย
const FUNCTIONS = [
  { key: "contact", label: "ข้อมูลติดต่อ Admin", desc: "ชื่อผู้ติดต่อและช่องทางที่โชว์บนหน้าประกาศ" },
  { key: "company", label: "ข้อมูลบริษัท", desc: "โลโก้ ข้อมูลบริษัท และช่องทางติดต่อของโครงการนี้" },
  { key: "listing", label: "การประกาศขาย", desc: "เลือกว่าหน้ารายละเอียดทรัพย์จะแสดงอะไรบ้าง" },
];

// ข้อมูลบริษัท + ช่องทางติดต่อ (ตาราง SaleSiteSettings 1 โครงการ 1 แถว)
const EMPTY_COMPANY = {
  logo_url: "",
  company_name_th: "",
  company_name_en: "",
  tax_number: "",
  license_number: "",
  office_phone: "",
  hotline: "",
  email: "",
  website: "",
  line_id: "",
  facebook: "",
  address: "",
};

// โครงของหน้ารายละเอียดทรัพย์บนเว็บขาย — เรียงตามลำดับจริงบนหน้าเว็บ
// items = หัวข้อย่อยในการ์ดนั้น (ปิดทีละอันได้)
const SALE_DISPLAY_SECTIONS = [
  { key: "gallery", label: "รูปภาพทรัพย์ (แกลเลอรี)", items: [] },
  {
    key: "header",
    label: "หัวประกาศ + ราคา",
    items: [
      { key: "spec_area", label: "ตร.ม." },
      { key: "spec_land", label: "ตร.ว." },
      { key: "spec_bedroom", label: "ห้องนอน" },
      { key: "spec_bathroom", label: "ห้องน้ำ" },
      { key: "spec_floor", label: "ชั้น" },
      { key: "spec_building", label: "อาคาร" },
      { key: "spec_parking", label: "ที่จอดรถ" },
      { key: "price_sale", label: "ราคาขาย" },
      { key: "price_rent", label: "ค่าเช่า/เดือน" },
      { key: "price_deposit", label: "เงินประกัน" },
    ],
  },
  { key: "description", label: "รายละเอียด", items: [] },
  { key: "highlight", label: "จุดเด่นของทรัพย์", items: [] },
  { key: "facilities", label: "ของใช้ภายในห้อง", items: [] },
  {
    key: "contact",
    label: "ติดต่อสอบถาม / นัดชมทรัพย์",
    items: [
      { key: "contact_phone", label: "โทร" },
      { key: "contact_line", label: "LINE" },
      { key: "contact_email", label: "อีเมล" },
      { key: "contact_inquiry", label: "สนใจทรัพย์นี้" },
    ],
  },
  {
    key: "property_info",
    label: "ข้อมูลทรัพย์",
    items: [
      { key: "info_property_type", label: "ประเภททรัพย์" },
      { key: "info_listing_type", label: "ประเภทประกาศ" },
      { key: "info_project", label: "โครงการ" },
      { key: "info_room_no", label: "ห้องเลขที่" },
      { key: "info_building", label: "อาคาร" },
      { key: "info_floor", label: "ชั้น" },
      { key: "info_area", label: "พื้นที่ใช้สอย" },
      { key: "info_land", label: "เนื้อที่ดิน" },
      { key: "info_bedroom", label: "ห้องนอน" },
      { key: "info_bathroom", label: "ห้องน้ำ" },
      { key: "info_parking", label: "ที่จอดรถ" },
      { key: "info_status", label: "สถานะ" },
    ],
  },
  {
    key: "location",
    label: "ทำเลที่ตั้ง",
    items: [
      { key: "loc_address", label: "ที่อยู่" },
      { key: "loc_map", label: "ดูใน Google Maps" },
    ],
  },
  { key: "nearby", label: "ทรัพย์ใกล้เคียง", items: [] },
];

// ชื่อเริ่มต้นของทุกหัวข้อ (การ์ดใหญ่ + รายการย่อย) — ใช้เมื่อผู้ดูแลยังไม่แก้ หรือลบจนว่าง
const LABEL_DEFAULTS = SALE_DISPLAY_SECTIONS.reduce((acc, section) => {
  acc[section.key] = section.label;
  section.items.forEach((item) => {
    acc[item.key] = item.label;
  });
  return acc;
}, {});
const LABEL_MAX_LENGTH = 100;

// หัวข้อที่หน้า /room ไม่มีข้อความให้แสดงจริง (แสดงเป็นรูป/ตัวเลข/ข้อมูลล้วน) — แก้ชื่อไม่เห็นผล
// จึงไม่ให้พิมพ์ (ยังเปิด/ปิดได้ตามเดิม) และไม่ส่งไปบันทึก
const NON_EDITABLE_LABEL_KEYS = ["gallery", "header", "price_sale", "price_rent", "contact_email", "loc_address"];
const isLabelEditable = (key) => !NON_EDITABLE_LABEL_KEYS.includes(key);

const SALE_SITE_URL = (process.env.REACT_APP_SALE_SITE_URL || "").replace(/\/+$/, "");

export default class SaleProjectSettings extends Component {
  state = {
    active: "contact",
    form: {
      contact_name: "",
      contact_phone: "",
      contact_line: "",
      contact_email: "",
      display: {},
      // ชื่อหัวข้อที่แก้ (เฉพาะคีย์ที่แก้) — คีย์ที่ไม่มี = ใช้ LABEL_DEFAULTS
      labels: {},
    },
    saving: false,
    loaded: false,
    errorMessage: "",

    // ---------- ข้อมูลบริษัท ----------
    company: { ...EMPTY_COMPANY },
    company_saving: false,
    company_loaded: false,
    company_error: "",
    company_is_default: false,
    company_uploading: false,
  };

  async componentDidMount() {
    if (!localStorage.getItem("cds-acc-tk")) {
      localStorage.clear();
      window.location.href = "/";
      return;
    }
    loading(false);
    await this.load();
    await this.loadCompany();
  }

  load = async () => {
    loading(true);
    const result = await GET("api/admin/sale-project-settings");
    loading(false);
    if (!result?.status) {
      // ★ ยิงไม่ผ่านส่วนใหญ่คือยังไม่ได้เลือกโครงการ (ตัวตั้งค่าผูกกับโครงการ)
      this.setState({ loaded: true, errorMessage: result?.message || "เปิดหน้านี้ไม่ได้ กรุณาเลือกโครงการก่อน" });
      return;
    }
    const data = result.data || {};
    this.setState({
      loaded: true,
      errorMessage: "",
      form: {
        contact_name: data.contact_name || "",
        contact_phone: data.contact_phone || "",
        contact_line: data.contact_line || "",
        contact_email: data.contact_email || "",
        display: data.display || {},
        labels: data.labels || {},
      },
    });
  };

  // ชื่อที่แสดงในช่อง: ที่แก้ไว้ ไม่งั้นค่าเริ่มต้น
  labelOf = (key) => {
    const value = this.state.form.labels[key];
    return value === undefined ? LABEL_DEFAULTS[key] : value;
  };

  setLabel = (key, value) =>
    this.setState((prev) => ({ form: { ...prev.form, labels: { ...prev.form.labels, [key]: value } } }));

  // ลบจนว่าง = กลับไปใช้ค่าเริ่มต้นทันทีเมื่อออกจากช่อง
  resetLabelIfEmpty = (key) => {
    if (String(this.state.form.labels[key] ?? "").trim()) return;
    this.setState((prev) => {
      const labels = { ...prev.form.labels };
      delete labels[key];
      return { form: { ...prev.form, labels } };
    });
  };

  labelInput = (key, style) =>
    !isLabelEditable(key) ? (
      <span style={style}>{LABEL_DEFAULTS[key]}</span>
    ) : (
    <input
      className="prop-field"
      style={style}
      type="text"
      maxLength={LABEL_MAX_LENGTH}
      data-testid={`label-${key}`}
      aria-label={`ชื่อหัวข้อ (ค่าเริ่มต้น: ${LABEL_DEFAULTS[key]})`}
      placeholder={LABEL_DEFAULTS[key]}
      value={this.labelOf(key)}
      onChange={(e) => this.setLabel(key, e.target.value)}
      onBlur={() => this.resetLabelIfEmpty(key)}
    />
    );

  setField = (key, value) => this.setState((prev) => ({ form: { ...prev.form, [key]: value } }));

  // คีย์ที่ยังไม่เคยตั้งค่า = ถือว่าเปิด (ตรงกับ default ฝั่ง backend)
  isOn = (key) => this.state.form.display[key] !== false;

  toggle = (key) =>
    this.setState((prev) => ({
      form: { ...prev.form, display: { ...prev.form.display, [key]: prev.form.display[key] === false } },
    }));

  // ปิดการ์ดหลัก = ปิดหัวข้อย่อยทั้งใบตามไปด้วย (หน้าเว็บไม่แสดงทั้งบล็อกอยู่แล้ว
  // ถ้าปล่อยให้ย่อยยังเปิดค้าง เปิดการ์ดกลับมาแล้วจะงงว่าทำไมบางอันหาย)
  toggleSection = (section) => {
    const next = !this.isOn(section.key);
    this.setState((prev) => {
      const display = { ...prev.form.display, [section.key]: next };
      section.items.forEach((item) => {
        display[item.key] = next;
      });
      return { form: { ...prev.form, display } };
    });
  };

  save = async () => {
    const { form, loaded, errorMessage, saving } = this.state;
    // ★ โหลดไม่สำเร็จ = ฟอร์มยังเป็นค่าว่าง/สวิตช์เปิดทุกอัน กดบันทึกแล้วเขียนทับค่าจริงใน DB
    if (!loaded || errorMessage || saving) return;
    this.setState({ saving: true });
    loading(true);
    const result = await PUT("api/admin/sale-project-settings", {
      contact_name: form.contact_name || null,
      contact_phone: form.contact_phone || null,
      contact_line: form.contact_line || null,
      contact_email: form.contact_email || null,
      display: form.display,
      // ส่งเฉพาะชื่อที่ต่างจากค่าเริ่มต้น (ว่าง/เท่าค่าเริ่มต้น = ไม่เก็บ → หน้าเว็บใช้ค่าเริ่มต้น)
      labels: Object.keys(LABEL_DEFAULTS).filter(isLabelEditable).reduce((acc, key) => {
        const value = String(form.labels[key] ?? "").trim();
        return value && value !== LABEL_DEFAULTS[key] ? { ...acc, [key]: value } : acc;
      }, {}),
    });
    loading(false);
    this.setState({ saving: false });
    if (!result?.status) return;
    await alert("", "success", "สำเร็จ", "บันทึกการตั้งค่าเรียบร้อย");
    await this.load();
  };

  // ---------- ข้อมูลบริษัท (ของโครงการที่ล็อกอินอยู่) ----------

  loadCompany = async () => {
    const result = await GET("api/admin/sale-site-settings", null, false);
    // ★ โหลดไม่สำเร็จ = ห้ามให้กดบันทึก — ฟอร์มยังเป็นค่าว่าง กดบันทึกแล้วข้อมูลบริษัทเดิมถูกเขียนทับเป็นค่าว่างทั้งชุด
    if (!result?.status) {
      this.setState({
        company_loaded: true,
        company_error: result?.message || "โหลดข้อมูลบริษัทไม่สำเร็จ กรุณารีเฟรชหน้าอีกครั้ง",
      });
      return;
    }
    // API คืน null ในช่องที่ยังไม่ได้กรอก แต่ input ของ React รับ null ไม่ได้
    // (จะกลายเป็น uncontrolled) จึงแปลงเป็นสตริงว่างทุกช่อง
    const data = result.data || {};
    const company = { ...EMPTY_COMPANY };
    Object.keys(EMPTY_COMPANY).forEach((k) => { company[k] = data[k] || ""; });
    this.setState({ company, company_is_default: !!data.is_default, company_loaded: true, company_error: "" });
  };

  setCompany = (key, value) => this.setState((prev) => ({ company: { ...prev.company, [key]: value } }));

  pickLogo = async (event) => {
    const file = (event.target.files || [])[0];
    event.target.value = "";
    if (!file) return;

    // โลโก้ใช้พื้นที่เล็ก ย่อที่ 512 ตามขนาดที่แนะนำ
    this.setState({ company_uploading: true });
    const base64 = await new Promise((resolve) => {
      Resizer.imageFileResizer(file, 512, 512, "PNG", 100, 0, (uri) => resolve(uri), "base64");
    });
    this.setState({ company_uploading: false });
    this.setCompany("logo_url", base64);
  };

  saveCompany = async () => {
    const { company, company_loaded, company_error, company_saving } = this.state;
    if (!company_loaded || company_error || company_saving) return;
    if (!company.company_name_th.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อบริษัท (ไทย)");
      return;
    }
    // ★ ช่องอีเมลมี * และ backend บังคับ (sale-site-setting.service.js) — ตรวจก่อนยิง จะได้ไม่เจอ error จาก server
    //   ค่าเริ่มต้นที่ดึงจากข้อมูลโครงการไม่มีอีเมล บันทึกครั้งแรกต้องกรอกเอง
    if (!company.email.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกอีเมล");
      return;
    }

    this.setState({ company_saving: true });
    loading(true);
    const result = await PUT("api/admin/sale-site-settings", company);
    loading(false);
    this.setState({ company_saving: false });

    if (result?.status) {
      await this.loadCompany();
      alert("", "success", "สำเร็จ", "บันทึกข้อมูลบริษัทเรียบร้อย");
    }
  };

  // เปิดหน้าตัวอย่างของเว็บขายในแท็บใหม่
  //
  // ★ ใช้ "ข้อมูลทดสอบ" (โหมด preview=1 ของหน้า /room) ไม่ผูกกับห้องจริง
  //   เพราะหน้าเว็บสาธารณะแสดงเฉพาะประกาศที่เผยแพร่แล้ว โครงการที่ยังไม่มีห้องเผยแพร่
  //   จะกดดูตัวอย่างไม่ได้เลย และผู้ดูแลก็ไม่ควรต้องเผยแพร่ห้องจริงเพื่อดูหน้าตาเว็บ
  // ★ ตัวอย่างสะท้อน "ค่าที่บันทึกแล้ว" — สวิตช์ที่เพิ่งกดแต่ยังไม่บันทึกจะยังไม่เห็น
  openPreview = () => {
    if (!SALE_SITE_URL) {
      alert("", "warning", "ยังไม่ได้ตั้งค่าหน้าตัวอย่างเว็บ", "ระบบยังไม่ได้ตั้งค่า URL ของหน้า Sale Page กรุณาติดต่อผู้ดูแลระบบ");
      return;
    }

    const projectId = getCurrentProject()?.project_id || "";
    window.open(
      `${SALE_SITE_URL}/room?preview=1${projectId ? `&project=${encodeURIComponent(projectId)}` : ""}`,
      "_blank"
    );
  };

  // ---------- ชิ้นส่วน ----------

  switch = (key, label, hint) => (
    <div className="d-flex justify-content-between align-items-center gap-3 py-2" key={key}>
      <div className="flex-grow-1">
        {this.labelInput(key, { fontWeight: this.isOn(key) ? 700 : 400 })}
        {!!hint && <div className="pf-hint">{hint}</div>}
      </div>
      <div className="form-check form-switch mb-0">
        <input
          className="form-check-input pointer"
          type="checkbox"
          style={{ width: 44, height: 22 }}
          checked={this.isOn(key)}
          onChange={() => this.toggle(key)}
        />
      </div>
    </div>
  );

  input = (key, label, opts = {}) => (
    <div className="pf-section">
      <label className="prop-label">{label}</label>
      <input
        className="prop-field"
        type={opts.type || "text"}
        inputMode={opts.phone ? "numeric" : undefined}
        maxLength={opts.phone ? 10 : opts.maxLength}
        placeholder={opts.placeholder || ""}
        value={this.state.form[key]}
        // ★ ช่องเบอร์โทร : ตัวเลขล้วน ไม่เกิน 10 หลัก
        onChange={(e) => this.setField(key, opts.phone ? onlyPhoneDigits(e.target.value) : e.target.value)}
      />
      {!!opts.hint && <div className="pf-hint">{opts.hint}</div>}
    </div>
  );

  renderContact = () => (
    <div className="prop-card prop-in">
      <div className="prop-card__head">
        <span className="prop-title text-16">
          <span className="prop-title__dot" />
          ข้อมูลติดต่อ Admin
        </span>
      </div>
      <div className="p-4">
        <div className="row g-3">
          <div className="col-12 col-md-6">
            {this.input("contact_name", "ชื่อ นามสกุล (ชื่อเล่น)", { placeholder: "เช่น สมชาย ใจดี (ชาย)" })}
          </div>
          <div className="col-12 col-md-6">{this.input("contact_phone", "เบอร์โทรศัพท์", { phone: true, placeholder: "0812345678" })}</div>
          <div className="col-12 col-md-6">{this.input("contact_line", "LINE", { placeholder: "LINE ID หรือลิงก์ไลน์" })}</div>
          <div className="col-12 col-md-6">{this.input("contact_email", "อีเมล", { type: "email", placeholder: "name@example.com" })}</div>
        </div>
        <div className="pf-hint mt-2">
          ข้อมูลชุดนี้แสดงบนหน้าประกาศของโครงการ ใช้เป็นช่องทางให้ผู้สนใจติดต่อกลับ
        </div>
      </div>
    </div>
  );

  companyInput = (key, label, opts = {}) => (
    <div className="pf-section">
      <label className="prop-label">
        {label}
        {opts.required && <span className="text-danger"> *</span>}
      </label>
      <input
        className="prop-field"
        type={opts.type || "text"}
        inputMode={opts.phone ? "numeric" : undefined}
        maxLength={opts.phone ? 10 : opts.maxLength}
        placeholder={opts.placeholder || ""}
        value={this.state.company[key]}
        // ★ ช่องเบอร์โทร : ตัวเลขล้วน ไม่เกิน 10 หลัก
        onChange={(e) => this.setCompany(key, opts.phone ? onlyPhoneDigits(e.target.value) : e.target.value)}
      />
      {!!opts.hint && <div className="pf-hint">{opts.hint}</div>}
    </div>
  );

  renderCompany = () => {
    const { company, company_saving, company_uploading, company_is_default, company_loaded, company_error } = this.state;
    const canUpdate = hasPermission("sale-project-settings.update");
    return (
      <div className="prop-card prop-in">
        <div className="prop-card__head">
          <span className="prop-title text-16">
            <span className="prop-title__dot" />
            ข้อมูลบริษัท
          </span>
        </div>
        <div className="p-4">
          <div className="pf-hint mb-3">
            ใช้แสดงบนหน้าเว็บไซต์ขายของโครงการนี้ (โลโก้ ชื่อ ที่อยู่ และเบอร์ ขึ้นบนการ์ดโครงการ)
            และเป็นข้อมูลติดต่อของประกาศในโครงการนี้ (ไม่มีผลกับโครงการอื่น)
          </div>
          {!!company_error && <div className="pf-hint mb-3 text-danger">{company_error}</div>}
          {company_is_default && (
            <div className="pf-hint mb-3 text-warning">
              ยังไม่เคยบันทึก · ค่าที่เห็นดึงมาจากข้อมูลโครงการ ตรวจสอบแล้วกด "บันทึกข้อมูลบริษัท"
            </div>
          )}

          <div className="row g-3">
            <div className="col-12 col-md-3 col-xl-2 text-center">
              <input hidden accept="image/png,image/*" id="company-logo-input" type="file" onChange={this.pickLogo} />
              <div
                className="border border-2 border-dash rounded-4 d-flex align-items-center justify-content-center pointer overflow-hidden mx-auto"
                style={{ width: 140, height: 140, background: "#f6f8fa" }}
                onClick={() => document.getElementById("company-logo-input").click()}
              >
                {company.logo_url ? (
                  <img
                    src={company.logo_url}
                    alt="โลโก้บริษัท"
                    style={{ width: "100%", height: "100%", objectFit: "contain" }}
                  />
                ) : (
                  <div className="text-center text-secondary">
                    <div className="icon text-32">{""}</div>
                    <small>เลือกโลโก้</small>
                  </div>
                )}
              </div>
              <small className="text-secondary d-block mt-2">
                {company_uploading ? "กำลังย่อรูป..." : "แนะนำ PNG พื้นหลังโปร่งใส 512 × 512 px"}
              </small>
              {!!company.logo_url && (
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger mt-2"
                  onClick={() => this.setCompany("logo_url", "")}
                >
                  ลบโลโก้
                </button>
              )}
            </div>

            <div className="col-12 col-md-9 col-xl-10">
              <div className="row g-3">
                <div className="col-12 col-lg-6">{this.companyInput("company_name_th", "ชื่อบริษัท (ไทย)", { required: true })}</div>
                <div className="col-12 col-lg-6">{this.companyInput("company_name_en", "ชื่อบริษัท (อังกฤษ)")}</div>
                <div className="col-12 col-lg-6">{this.companyInput("tax_number", "เลขประจำตัวผู้เสียภาษี")}</div>
                <div className="col-12 col-lg-6">
                  {this.companyInput("license_number", "เลขที่ใบอนุญาตนายหน้า", { hint: "แสดงท้ายประกาศตามข้อกำหนดของ ก.ล.ต. อสังหาฯ" })}
                </div>
              </div>
            </div>
          </div>

          <hr className="my-4" />

          <div className="prop-title text-16 mb-3">
            <span className="prop-title__dot" />
            ช่องทางติดต่อ
          </div>
          <div className="row g-3">
            <div className="col-12 col-md-6 col-xl-4">{this.companyInput("office_phone", "เบอร์สำนักงาน", { phone: true, placeholder: "0212345678" })}</div>
            <div className="col-12 col-md-6 col-xl-4">{this.companyInput("hotline", "สายด่วน", { phone: true, placeholder: "0812345678" })}</div>
            <div className="col-12 col-md-6 col-xl-4">{this.companyInput("email", "อีเมล", { type: "email", required: true, placeholder: "name@example.com" })}</div>
            <div className="col-12 col-md-6 col-xl-4">{this.companyInput("website", "เว็บไซต์")}</div>
            <div className="col-12 col-md-6 col-xl-4">{this.companyInput("line_id", "LINE Official Account")}</div>
            <div className="col-12 col-md-6 col-xl-4">{this.companyInput("facebook", "Facebook Page")}</div>
            <div className="col-12">
              <label className="prop-label">ที่อยู่บริษัท</label>
              <textarea
                className="prop-field"
                rows={3}
                value={company.address}
                onChange={(e) => this.setCompany("address", e.target.value)}
              />
            </div>
          </div>

          <div className="d-flex justify-content-end mt-3">
            {/* ★ ไม่มีสิทธิ์ sale-project-settings.update = กดแล้วโดน 403 จึงไม่แสดงปุ่ม */}
            {canUpdate && (
              <button
                type="button"
                className="prop-btn"
                disabled={company_saving || !company_loaded || !!company_error}
                onClick={this.saveCompany}
              >
                <span className="icon text-14">{""}</span>
                {company_saving ? "กำลังบันทึก..." : "บันทึกข้อมูลบริษัท"}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  renderDisplay = () => (
    <>
      <div className="prop-card prop-in mb-3">
        <div className="p-3 d-flex flex-wrap justify-content-between align-items-center gap-2">
          <div className="text-14 text-secondary">
            ปิดสวิตช์ = ไม่แสดงบล็อกนั้นบนหน้าเว็บประกาศขาย · การ์ดที่ปิดจะจางลงให้เห็นชัดว่าเหลืออะไรบ้าง
            <div className="text-12">แก้ชื่อหัวข้อได้ในช่องข้อความ · ลบจนว่างจะกลับไปใช้ชื่อเริ่มต้น</div>
            <div className="text-12">ตัวอย่างแสดงค่าที่บันทึกแล้ว — กดบันทึกก่อนดูตัวอย่าง</div>
          </div>
          <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm" onClick={this.openPreview}>
            <span className="icon text-12">{""}</span> ดูตัวอย่างหน้าเว็บ
          </button>
        </div>
      </div>

      <div className="row g-3">
        {SALE_DISPLAY_SECTIONS.map((section) => {
          const on = this.isOn(section.key);
          return (
            <div className="col-12 col-xl-6" key={section.key}>
              <div
                className="prop-card prop-in h-100"
                data-testid={`display-card-${section.key}`}
                style={on ? undefined : { opacity: 0.5, filter: "grayscale(1)" }}
              >
                <div className="prop-card__head">
                  <span className="prop-title text-16 flex-grow-1 me-3">
                    <span className="prop-title__dot" />
                    {this.labelInput(section.key, { fontWeight: 700 })}
                  </span>
                  <div className="form-check form-switch mb-0">
                    <input
                      className="form-check-input pointer"
                      type="checkbox"
                      style={{ width: 44, height: 22 }}
                      checked={on}
                      onChange={() => this.toggleSection(section)}
                    />
                  </div>
                </div>
                <div className="p-3">
                  {section.items.length ? (
                    section.items.map((item) => this.switch(item.key, item.label))
                  ) : (
                    <div className="text-secondary text-12">
                      {on ? "แสดงบนหน้าเว็บ" : "ไม่แสดงบนหน้าเว็บ"}
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );

  render() {
    const { active, loaded, saving, errorMessage } = this.state;
    const project = getCurrentProject();

    return (
      <div className="w-100 min-vh-100 prop-page">
        <PropertyNavbar menuKey="sales-project-settings" page1="ตั้งค่า" page2="การตั้งค่าการขาย (โครงการ)" projectName={project?.project_name} />

        <div className="body p-4">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">การตั้งค่าการขาย (โครงการ)</h3>
              <div className="text-secondary text-14">
                {stripJuristic(project?.project_name) || "-"} · ตั้งค่าข้อมูลติดต่อและสิ่งที่จะแสดงบนหน้าเว็บประกาศขาย
              </div>
            </div>
            {/* แท็บ "ข้อมูลบริษัท" มีปุ่มบันทึกของตัวเองท้ายฟอร์ม (คนละ state/คนละ endpoint) */}
            {active !== "company" && hasPermission("sale-project-settings.update") && (
              <button type="button" className="prop-btn" disabled={saving || !loaded || !!errorMessage} onClick={this.save}>
                <span className="icon text-14">{""}</span>
                {saving ? "กำลังบันทึก..." : "บันทึกการตั้งค่า"}
              </button>
            )}
          </div>

          <div className="row g-3">
            {/* ---------------- ซ้าย : เลือกฟังก์ชันที่จะตั้งค่า ---------------- */}
            <div className="col-12 col-lg-3">
              <div className="prop-card prop-in">
                <div className="p-2">
                  {FUNCTIONS.map((item) => (
                    <button
                      key={item.key}
                      type="button"
                      data-testid={`fn-${item.key}`}
                      className={`btn w-100 text-start p-3 mb-1 rounded-3 ${
                        active === item.key ? "btn-success" : "btn-outline-dark border-0"
                      }`}
                      onClick={() => this.setState({ active: item.key })}
                    >
                      <div className="fw-bold">{item.label}</div>
                      <div className={`text-12 ${active === item.key ? "text-white-50" : "text-secondary"}`}>
                        {item.desc}
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* ---------------- ขวา : ฟอร์มของฟังก์ชันที่เลือก ---------------- */}
            <div className="col-12 col-lg-9">
              {/* "ข้อมูลบริษัท" ใช้ endpoint ของตัวเอง (sale-site-settings) — สถานะโหลด/ปุ่มบันทึกแยกจากแท็บอื่น */}
              {active === "company" ? (
                this.renderCompany()
              ) : !loaded ? (
                <div className="prop-card prop-in p-5 text-center text-secondary">กำลังโหลดข้อมูล...</div>
              ) : errorMessage ? (
                <div className="prop-card prop-in p-5 text-center text-secondary">{errorMessage}</div>
              ) : active === "contact" ? (
                this.renderContact()
              ) : (
                this.renderDisplay()
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
